import { render, staticRenderFns } from "./licences.vue?vue&type=template&id=7d3f6982&"
import script from "./licences.vue?vue&type=script&lang=js&"
export * from "./licences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports